import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { getBamOnlineCTAStyle } from 'constants/buttonStyle';
import { StyledCTAProps } from 'types/bamOnlineCTA';

export const StyledLink = styled(Link)<StyledCTAProps>`
  ${({ secondary, light }) => getBamOnlineCTAStyle(secondary, light)}
`;
StyledLink.displayName = 'StyledLink';
